import { render, staticRenderFns } from "./DataCleansing.vue?vue&type=template&id=64a4f25a"
import script from "./DataCleansing.vue?vue&type=script&lang=js"
export * from "./DataCleansing.vue?vue&type=script&lang=js"
import style0 from "./DataCleansing.vue?vue&type=style&index=0&id=64a4f25a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports